/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const HH = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="600"
    height="400"
    {...props}
    viewBox="0 0 600 400"
  >
    <rect
      width="600"
      height="400"
      fill="#da121a"
    />
    <g stroke="#000">
      <g fill="#fff">
        <g strokeWidth="1.2">
          <path d="m309.3 75.37s0.5078-8.848-7.287-10.24v-9.525h6.27v-4.067h-6.27v-5.204h-3.886v5.204h-6.27v4.067h6.27v9.525c-7.795 1.391-7.287 10.24-7.287 10.24" />
          <path d="m277.9 94.91h44.14c1e-7 -11.98-11.11-21.58-22.07-21.58s-22.07 9.6-22.07 21.58z" />
          <path d="m322.9 105.5 2.5-0.853v-9.747h-50.73v9.747l2.5 0.853z" />
          <path d="m322.4 200.6v-95.11h-44.85v95.11" />
        </g>
        <path d="m207.9 276.7c7.371-33.4 4.699-66.48 4.699-66.48h174.8s-2.672 33.08 4.699 66.48c7.999 36.26 15.17 48.8 15.17 48.8v14.59h-214.5l-0.019-14.59s7.148-12.54 15.15-48.8z" />
      </g>
      <g
        id="b"
        fill="none"
      >
        <g
          strokeWidth="1.2"
          fill="#fff"
        >
          <path d="m233.9 82.39h8.365v11.13h5.4v-11.13h8.688v11.13h5.717v-11.13h8.319v21.92l-2.792 1.205h-45.46l-3.361-1.205v-21.92h8.745v11.13h6.383z" />
          <path d="m222.1 105.5h45.4v96.43h-45.4z" />
          <path d="m232.6 69.3 4.12-7.13-4.12-7.13h8.24l4.12-7.13 4.12 7.13h8.24l-4.12 7.13 4.12 7.13h-8.24l-4.12 7.14-4.12-7.14z" />
          <path d="m301 185.4h-8.031v13.06h-13.05v-13.06h-14.34v13.06h-11.96v-13.06h-13.88v13.06h-11.87v-13.06h-16.17v24.74l3.852 0.9395h85.45" />
        </g>
        <path
          strokeWidth="2"
          d="m222.1 106h45.36"
        />
        <path
          strokeWidth="2.5"
          d="m266.4 340.1v-73.78c0-6.687 9.045-30.81 33.6-30.81"
        />
        <path d="m277 340.1v-69.84c0-11.39 9.074-24.43 23-24.43" />
        <path
          id="a"
          fill="#000"
          d="m283.9 321.3c0-3.16 1.18-3.16 2.1-3.16 0.93 0-0.11 1.27-0.11 3s1 3.3 0.11 3.3-2.1-0.28-2.1-3.16zm-6.9-0.1h6.451"
        />
        <path
          strokeWidth="2"
          d="m193 325.5h73"
        />
        <use y="-50" />
      </g>
      <use transform="matrix(-1,0,0,1,600,0)" />
      <path
        d="m212.2 210.2h175.6m-110-104.2h44.16"
        strokeWidth="2"
      />
      <path d="m300 245.8v94.27" />
    </g>
  </svg>
);
export default memo(HH);
